import { logWrapper } from '../utils';

export default {
  exportedMediaModel: [
    'runtimeConstant',
    '$filter',
    'validationService',
    function (runtimeConstant, $filter, validationService) {
      function ExportedMedia(data) {
        if (!data) {
          data = {};
          data.Id = 0;
          data.IdUser = 0;
          data.IdCompany = 0;
          data.IdFolder = 0;
          data.Name = '';
          data.Status = -1;
          data.MediaType = 0;
          data.Company = null;
          data.Folder = null;
        }

        this.id = data.Id;
        this.idUser = data.IdUser;
        this.idCompany = data.IdCompany;
        this.idFolder = data.IdFolder;
        this.name = data.Name;
        this.dateCreated = data.DateCreated
          ? new Date(Date.parse(data.DateCreated))
          : null;
        this.dateStarted = data.DateStarted
          ? new Date(Date.parse(data.DateStarted))
          : null;
        this.dateFinished = data.DateFinished
          ? new Date(Date.parse(data.DateFinished))
          : null;
        this.status = data.Status;
        this.mediaType = data.MediaType;
        this.company = data.Company;
        this.folder = data.Folder;

        this.statusEnum = [
          {
            id: 0,
            name: 'WAITING',
          },
          {
            id: 1,
            name: 'STARTED',
          },
          {
            id: 2,
            name: 'FINISHED',
          },
          {
            id: 3,
            name: 'MEDIA ERROR',
          },
        ];

        this.mediaTypeEnum = [
          {
            id: 1,
            name: 'SIMPLE_MEDIA',
          },
          {
            id: 2,
            name: 'SEARCHABLE_MEDIA',
          },
        ];

        this.status = this.statusEnum.find(function (s) {
          return s.id === data.Status;
        });
        this.mediaType = this.mediaTypeEnum.find(function (mt) {
          return mt.id === data.MediaType;
        });
      }

      function title() {
        return this.name;
      }

      function details() {
        if (typeof this.status !== 'undefined') {
          var detail;
          detail = $filter('translate')('MEDIA STATUS');
          detail += ': ';
          detail += $filter('translate')(this.status.name);
          return detail;
        } else {
          return null;
        }
      }

      function tags() {
        var tags = [];
        var tag;

        tag = $filter('translate')('MEDIA TYPE');
        tag += ': ';
        tag += $filter('translate')(this.mediaType.name);

        tags.push(tag);

        return tags;
      }

      function isCnpjValid() {
        return (
          this.company.Cnpj.length === 0 ||
          validationService.validateCNPJ(this.company.Cnpj)
        );
      }

      function isValid() {
        return this.isCpnjValid;
      }

      function run() {
        try {
          ExportedMedia.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            isCnpjValid: logWrapper(
              isCnpjValid,
              runtimeConstant.isDebugModelsInternals
            ),
            isValid: logWrapper(
              isValid,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return ExportedMedia;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }
      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
